import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Warning } from "@phosphor-icons/react";
import { fmtMoney } from "@/lib/api";

export default function RevertBatchDialog({ delBatch, onCancel, onConfirm }) {
  return (
    <AlertDialog open={!!delBatch} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading flex items-center gap-2">
            <Warning size={18} weight="fill" className="text-amber-600" />
            Revertir importación de ventas
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-[13px]">
              <p>
                ¿Eliminar el lote <span className="font-mono">{delBatch?.filename}</span>?
              </p>
              <p>
                Se borrarán <span className="font-mono font-semibold">{delBatch?.count}</span> facturas y los saldos de clientes se revertirán en{" "}
                <span className="font-mono font-semibold">{fmtMoney(delBatch?.total_delta || 0)}</span>.
              </p>
              {delBatch?.por_unidad && (
                <div className="text-[11px] font-mono text-[#666]">
                  Detalle: {Object.entries(delBatch.por_unidad).filter(([_, n]) => n > 0).map(([u, n]) => `${u}: ${n}`).join(" · ")}
                </div>
              )}
              <p className="text-red-700 pt-1">
                Los cobros aplicados a estas facturas quedarán huérfanos. Revisá primero.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-sm">Cancelar</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-revert-batch"
            onClick={onConfirm}
            className="rounded-sm bg-red-600 hover:bg-red-700"
          >
            Revertir lote
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
